import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchAvailableAddons = createAsyncThunk(
  'availableAddons/fetchAvailableAddons',
  async (_, { rejectWithValue }) => {
    const [success, response] = await httpRequest({
      url: '/api/billing/available_addons',
      method: 'GET'
    })

    if (!success) {
      return rejectWithValue(response)
    }

    return response
  }
)
